<template>
  <div class="fe-range">
    <el-form-item
      :label="endTitle | capitalize"
    >
      <div class="fe-range-content">
        <input ref="input" v-model="firstValue" placeholder="" :type="type" :step="step" :precision="precision" class="fe-range-input" :min="min" :max="secondValue"/>
        <span class="fe-range-separator">——</span>
        <input v-model="secondValue" placeholder="" :type="type" :step="step" :precision="precision" class="fe-range-input" :min="firstValue" max="10000"/>
      </div>
    </el-form-item>
  </div>
</template>
<script>
  import baseMixin from './mixin/base'
  export default {
    name: 'fe-range',
    mixins: [baseMixin],
    props: {
      text: String,
      precision: Number,
      value: {
        type: String | Array
      },
      step: Number
    },
    data() {
      return {
        min: 0.01,
        firstValue: '',
        secondValue: '',
        type: 'number'
      }
    },
    created() {
      if (process.env.PROJECT === 'wwka') {
        this.min = 0;
      }
    },
    watch: {
      value: {
        handler(val) {
          if (val) {
            this.firstValue = val.start
            this.secondValue = val.end
          } else {
            this.firstValue = val
            this.secondValue = val
          }
        },
        deep: true,
        immediate: true
      },
      firstValue: {
        handler(val) {
          // if (val) {
          // if (this.secondValue && (val - this.secondValue > 0)) {
          //   this.firstValue = this.secondValue
          //   return
          // }
          const retVal = { 'start': val, 'end': this.secondValue || '' }
          this.$emit('input', retVal)
          // }
        },
        deep: true,
        immediate: true
      },
      secondValue: {
        handler(val) {
          // if (val) {
          // if (this.firstValue && (val - this.firstValue < 0)) {
          //   this.secondValue = this.firstValue
          //   return
          // }
          const retVal = { 'start': this.firstValue || '', 'end': val }
          this.$emit('input', retVal)
          // }
        },
        deep: true,
        immediate: true
      }
    }
  }
</script>
<style type="text/scss" lang="scss" scoped>
  .fe-range{
    margin-top: 5px;
    margin-bottom: 5px;
    .el-form-item {
      margin-bottom: 0px !important;
    }
    .fe-range-content{
      width: 178px;
      float: left;
      border-radius: 4px;
      box-sizing: border-box;
      color: #606266;
      border: 1px solid #dcdfe6;
      .fe-range-separator{
        width: 12px;
        float: left;
      }
      .fe-range-input{
        width: 78px;
        height: 36px;
        border: none;
        outline: none;
        float: left;
        margin-left: 3px;
        text-align: center
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/FromBase/range.vue